// src/App.js
import React, { useState, useEffect } from "react";
import QuestionCard from './components/QuestionCard';
import './App.css';
import './style.css';
import './bootstrap.css';
import client from './components/contentfulClient';
import logoFooter from './images/logo-footer.svg';
import bannerImg from './images/banner-head.jpg';
import heroFirearmHeader from './images/hero_firearm-header.png';
import logosPartnership from './images/logos_partnership.jpg';

function App() {
  console.log('Firearm Injury Prevention app started.');
  const currentYear = new Date().getFullYear();
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showScore, setShowScore] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [QuizData, setQuizData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [ansClicked, setAnsClicked] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const loopQuestionArr = (entries) => {
    let list = [];
    entries.map((entry) => (
      list.push(
        {
          question: entry.fields.title,
          answers: [
            { text: entry.fields.option1.content[0].content[0].value, isCorrect: (entry.fields.answer === 'option1') ? true : false },
            { text: entry.fields.option2.content[0].content[0].value, isCorrect: (entry.fields.answer === 'option2') ? true : false },
            { text: entry.fields.option3.content[0].content[0].value, isCorrect: (entry.fields.answer === 'option3') ? true : false },
            { text: entry.fields.option4.content[0].content[0].value, isCorrect: (entry.fields.answer === 'option4') ? true : false },
            { text: entry.fields.option5.content[0].content[0].value, isCorrect: (entry.fields.answer === 'option5') ? true : false },
          ],
          questionSummary: entry.fields.questionSummary.content,
          questionFeedback: entry.fields.questionFeedback.content,
          author: entry.fields.author.content[0].content,
          citations: entry.fields.citations.content,
          ansvalue: entry.fields.answer,
          learningObjective: entry.fields.learningObjective

        })
    ));
    console.log(list);
    return list;

  }
  useEffect(() => {
    // Fetch entries from Contentful
    client.getEntries().then((response) => {
      // Contentful response is filtered to fetch firearms safety records.
      const filteredItems = response.items.filter(
        (item) => item.sys?.contentType?.sys?.id === 'firearmsSafety'
      );
      console.log('filtered firearmsSafety items==', filteredItems);
      let enteries = loopQuestionArr(filteredItems);
      setQuizData(enteries);
      setLoading(false);
    })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const handleAnswerClick = (isCorrect, ansClicked, index, feedback, selectedOption) => {
    setAnsClicked(true);
    setSelectedOption(selectedOption);
    setSelectedIndex(index);
    if (isCorrect) {
      setScore(score + 1);
      setIsCorrect(isCorrect);
      setFeedback(feedback)
    }
  };
  const handleNextQuestion = (isCorrect) => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // This makes the scrolling smooth
    });
    setSelectedIndex(null);
    setFeedback(null);
    setSelectedOption(null); // Reset selection if needed
    if (isCorrect) {
      setAnsClicked(false);
      setIsCorrect(false);
      const nextQuestion = currentQuestion + 1;
      if (nextQuestion < QuizData.length) {
        setCurrentQuestion(nextQuestion);
      } else {
        setShowScore(true);
      }
    }
  };

  const handleQuestionForTrial = () => {

    const nextQuestion = currentQuestion;
    setSelectedIndex(null);
    setFeedback(null);
    setAnsClicked(false);
    setSelectedOption(null); // Reset selection if needed
    if (nextQuestion < QuizData.length) {
      setCurrentQuestion(nextQuestion);
    }
  };
  const returnToFirstQue = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // This makes the scrolling smooth
    });
    const nextQuestion = 0;
    setSelectedIndex(null);
    setFeedback(null);
    setAnsClicked(false);
    setSelectedOption(null); // Reset selection if needed
    setIsCorrect(false);
    if (nextQuestion < QuizData.length) {
      setCurrentQuestion(nextQuestion);
    }
  };
  return (
    <div className="app ">
      <div className="">
        <div className="banner">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-lg-7">
                <div className="banner__content">
                  <h1>Firearm Injury Prevention:<br /> Medical Student Education Program</h1>
                </div>
              </div>
              <div className="col-md-6 col-lg-5">
                <div className="banner-image">
                  <img src={heroFirearmHeader} width="auto" height="100%" alt="Locked gun" /></div>
              </div>
            </div>
          </div>
        </div>
        <nav className="navbar header">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12 col-lg-12"><img className="img-fluid" src={logosPartnership} align="center" width="800" height="auto" alt="In Partnership with Cincinnati Children's and Massachusetts General Hospital Gun Violence Prevention Center"/></div>
            </div>
          </div>
        </nav>

      </div>

      {/* </div> */}
      <div className="quiz-container">
        <h1 className="scala-ot">FIREARM INJURY PREVENTION QUIZ</h1>
        <QuestionCard
          learningObjective={QuizData[currentQuestion].learningObjective}
          answers={QuizData[currentQuestion].answers}
          currentQuestionIndex={currentQuestion}
          totalQuestions={QuizData.length}
          selectedIndexx={selectedIndex}
          questionSummary={QuizData[currentQuestion].questionSummary}
          questionFeedback={QuizData[currentQuestion].questionFeedback}
          author={QuizData[currentQuestion].author}
          citations={QuizData[currentQuestion].citations}
          ansClicked={ansClicked}
          series={currentQuestion + 1}
          onAnswerClick={handleAnswerClick}
          isAnsCorrect={isCorrect}
          selectedOption={selectedOption}
        />
        {
          (ansClicked && !isCorrect) ?
            <div className="container-btn">
              <div className="message">
                <p className="message-title">TRY AGAIN.</p>
                <p className="message-text">This is not the preferred answer.</p>
              </div>

              <button className="try-again-button" onClick={() => handleQuestionForTrial()}>  <span className="arrow">←</span> TRY AGAIN </button>
            </div>
            : ''
        }
        {
          (isCorrect && ((currentQuestion + 1) < QuizData.length)) ?
            <div className="container-btn">
              <button className="nextBtn try-again-button" onClick={() => handleNextQuestion(isCorrect)}>  NEXT QUESTION  <span className="arrow">→</span> </button>
            </div> : ''
        }
        {
          (isCorrect && ((currentQuestion + 1) === QuizData.length)) ?
            <span className="success-quiz-a"> Congratulations, you have completed the quiz</span> : ''
        }

      </div>
      <div className="return-button-wrap">
        {/* <!-- Return to Start Page Button --> */}
        <a href="https://cloud.info-nejm.org/firearm-injury-prevention" onClick={() => returnToFirstQue()} className="return-button">
          <span className="arrow"> ← </span> RETURN TO START PAGE
        </a>
      </div>


      {/* <!-- Footer Section --> */}
      <div className="footer mx-5">
        <p>Copyright © {currentYear} Massachusetts Medical Society. All rights reserved. Electronic ISSN 1533-4406. Print ISSN 0028-4793.
          <br />The content of this site is intended for health care professionals.</p>
        <div className="footer-left">
          <div className="footer-links">
            <a href="https://www.nejmgroup.org/legal/copyright-information.htm">Copyright</a> |
            <a href="https://www.nejmgroup.org/legal/terms-of-use.htm">Terms</a> |
            <a href="https://www.nejmgroup.org/legal/privacy-policy.htm">Privacy Policy</a>
          </div>
          <div className="footer-logo">
            <a href="https://www.nejmgroup.org/">
              <img src={logoFooter} alt=" Logo" />
            </a>
          </div>
        </div>

      </div>

    </div>
  );
}

export default App;
